import { Grid2, Typography } from "@mui/material";
import { CheckIcon, GKButton } from "components";
import GKModal from "components/GKModal";
import { RevenueManagerDetails } from "interfaces/Revenue";
import { useChangeFeePlanMutation } from "store/features/Revenue/FeePlan";
import { useAppSelector } from "store/store";

interface Props {
  open: {
    openModal: boolean;
    type: string;
    modalTitle: string;
  };
  setOpen: (open: {
    openModal: boolean;
    type: string;
    modalTitle: string;
  }) => void;
  feePlanModal?: (open: {
    open: boolean;
    type: string;
    modalTitle: string;
    width: string;
  }) => void;
  portfolioId: string;
  rowSelectionModel: string[];
  feePlanDetails: RevenueManagerDetails;
}

const ChangeFeePlanConfirmationContent = (props: Props) => {
  const {
    setOpen,
    portfolioId,
    rowSelectionModel,
    feePlanDetails,
    feePlanModal,
  } = props;

  const feePlan = useAppSelector((state) =>
    state.app?.feePlanList.find(
      (item) => item.value.toString() === rowSelectionModel.toString(),
    ),
  );

  const [changeFeePlan, { isLoading }] = useChangeFeePlanMutation();

  return (
    <Grid2 container spacing={"12px"}>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={500} color="var(--neutral-500)">
          You&apos;re about to change the fee plan,
        </Typography>
      </Grid2>
      <Grid2 container size={12} spacing={1}>
        <Grid2 size={12}>
          <Typography
            fontSize={12}
            fontWeight={500}
            color="var(--neutral-500)"
            display={"flex"}
            align="center"
            gap={1}
          >
            From:{" "}
            <Typography
              fontSize={12}
              fontWeight={500}
              color="var(--black)"
              component={"span"}
            >
              {feePlanDetails?.feePlan?.feePlanName || "-"}
            </Typography>
          </Typography>
        </Grid2>
        <Grid2 size={12}>
          <Typography
            fontSize={12}
            fontWeight={500}
            color="var(--neutral-500)"
            display={"flex"}
            align="center"
            gap={1}
          >
            To:{" "}
            <Typography
              fontSize={12}
              fontWeight={500}
              color="var(--black)"
              component={"span"}
            >
              {feePlan?.name || "-"}
            </Typography>
          </Typography>
        </Grid2>
      </Grid2>
      <Grid2 size={12}>
        <Typography fontSize={12} fontWeight={500} color="var(--neutral-500)">
          This will affect how fees are calculated moving forward.
        </Typography>
      </Grid2>
      <Grid2
        size={12}
        display={"flex"}
        alignItems={"center"}
        gap={1}
        mt={"28px"}
      >
        <GKButton
          variant="outlined"
          color="dark"
          fullWidth
          onClick={() =>
            setOpen({ openModal: false, modalTitle: "", type: "" })
          }
        >
          Cancel
        </GKButton>
        <GKButton
          variant="contained"
          fullWidth
          onClick={async () => {
            try {
              await changeFeePlan({
                portfolio: [portfolioId],
                feePlan: rowSelectionModel?.toString(),
              }).unwrap();
              feePlanModal({
                open: false,
                modalTitle: "",
                type: "",
                width: "",
              });
              setOpen({
                openModal: false,
                type: "",
                modalTitle: "",
              });
            } catch (error) {
              console.error("Error changing fee plan:", error);
            }
          }}
          startIcon={<CheckIcon />}
          loading={isLoading}
        >
          Confirm Change
        </GKButton>
      </Grid2>
    </Grid2>
  );
};

const ConfirmationModal = (props: Props) => {
  const {
    open,
    setOpen,
    portfolioId,
    rowSelectionModel,
    feePlanDetails,
    feePlanModal,
  } = props;

  const handleReturnComponent = (type: string) => {
    switch (type) {
      case "FEE_PLAN_CHANGE":
        return (
          <ChangeFeePlanConfirmationContent
            open={open}
            setOpen={setOpen}
            portfolioId={portfolioId}
            rowSelectionModel={rowSelectionModel}
            feePlanDetails={feePlanDetails}
            feePlanModal={feePlanModal}
          />
        );

      default:
        return <></>;
    }
  };
  return (
    <GKModal
      modalTitle={open?.modalTitle}
      open={open?.openModal}
      setOpen={() => setOpen({ openModal: false, type: "", modalTitle: "" })}
      width={"370px"}
    >
      <Grid2 container>{handleReturnComponent(open.type)}</Grid2>
    </GKModal>
  );
};

export default ConfirmationModal;
